import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { Divider, FormControlLabel, Grid, Switch } from "@mui/material";

import Input from "src/components/Input";
import Dropdown from "../Dropdown";
import DateTimeInput from "../DateTimeInput";

const AirasiaForm = styled(Grid)``;

const AirasisFormTitle = styled.span`
	font-family: "Roboto", "Helvetica", "Arial", sans-serif;
	font-size: 0.95rem;
	font-weight: 500;
	color: rgba(0, 0, 0, 0.77);
`;

const AA_VOUCHER_TYPE = [
	{ id: "flight", name: "Flight", lobName: "airasiaFlyBeyond" },
	{ id: "food", name: "Food", lobName: "airasiaFood" },
	{ id: "hotel", name: "Hotel", lobName: "airasiaHotel" },
	{ id: "shop", name: "Shop", lobName: "airasiaShop" },
];

const AirasiaDataForm = ({ formData, errors, onInputChange }) => {
	console.log(formData);
	const [aaData, setAAData] = useState(formData ? {...formData, isProductApproved: formData.isProductApproved || false} : {isProductApproved: false});


	const changeHandler = (event) => {
		const { id, value } = event.target;

		setAAData((prevState) => ({
			...prevState,
			[id]: value,
		}));
	};

	const inputPropsHandlers = {
		onChangeBlur: changeHandler,
	};

	const datePickerChangeHandler = (dateTimeValue) => {
		const { id, value } = dateTimeValue;

		setAAData((prevState) => ({
			...prevState,
			[id]: value,
		}));
	};

	const onChange = (key, value) => {
		setAAData((prevState) => ({
			...prevState,
			[key]: value,
		}));
	};

	useEffect(() => {
		onInputChange({ ...aaData });
	}, [aaData]); // eslint-disable-line react-hooks/exhaustive-deps

	const changeVoucherType = (selectedVoucher) => {
		const aaVoucherType = AA_VOUCHER_TYPE.find((voucher) => voucher.id === selectedVoucher.id);

		if (!aaVoucherType) return;

		setAAData((prevState) => ({
			...prevState,
			voucherType: aaVoucherType.id,
			lobName: aaVoucherType.lobName,
		}));
	};

	return (
		<Grid container item spacing={2}>
			<Grid item md={12} xs={12} spacing={3}>
				<Divider textAlign="center"></Divider>
			</Grid>
			<AirasiaForm container item spacing={2} md={12} xs={12}>
				<Grid item md={12} xs={12} spacing={3}>
					<AirasisFormTitle>Airasia Data</AirasisFormTitle>
				</Grid>
				<Grid container item spacing={2}>
					<Grid item md={12} xs={12}>
						<Dropdown options={[...AA_VOUCHER_TYPE]} placeholder="Select Voucher Type" id="voucherType" label="Voucher Type *" value={aaData && aaData.voucherType && aaData.voucherType.toLowerCase()} onSelectChange={changeVoucherType} error={!!errors.voucherType} />
					</Grid>
				</Grid>
				<Grid container item spacing={2}>
					<Grid item md={6} xs={6}>
						<Input {...inputPropsHandlers} disabled id="lobName" label="LoB Name" value={aaData.lobName || ""} error={errors.lobName} />
					</Grid>
				</Grid>
				{aaData && aaData.voucherType && aaData.voucherType.toLowerCase() !== "flight" && (
					<Grid container item spacing={2}>
						<Grid item md={6} xs={6}>
							<Input {...inputPropsHandlers} id="discountTemplateId" label="Discount Template Id" value={aaData.discountTemplateId} error={errors.discountTemplateId} />
						</Grid>
						<Grid item md={6} xs={6}></Grid>
					</Grid>
				)}
				{aaData && aaData.voucherType && aaData.voucherType.toLowerCase() === "flight" && (
					<Grid container item spacing={2}>
						<Grid item md={6} xs={6}>
							<Input {...inputPropsHandlers} id="voucherBasisCode" label="Voucher Basis Code" value={aaData.voucherBasisCode} error={!!errors.voucherBasisCode} />
						</Grid>
						<Grid item md={6} xs={6}>
							<Input {...inputPropsHandlers} id="issuanceReasonCode" label="Issuance Reason Code" value={aaData.issuanceReasonCode} error={!!errors.issuanceReasonCode} />
						</Grid>
					</Grid>
				)}
			</AirasiaForm>

			<Grid container item spacing={2}>
				<Grid item md={6} xs={6}>
					<DateTimeInput id="expirationDate" type="datetime" label="Voucher Expiration Date/Time" value={aaData.expirationDate || null} error={errors.expirationDate} onChange={datePickerChangeHandler} />
				</Grid>
			</Grid>
			<Grid container item spacing={2}>
				<Grid item md={6} xs={6}>
					<DateTimeInput id="productPublishDate" type="datetime" label="Product Publish Date/Time" value={aaData.productPublishDate || null} error={errors.productPublishDate} onChange={datePickerChangeHandler} />
				</Grid>
				<Grid item md={6} xs={6}>
					<DateTimeInput id="productExpiryDate" type="datetime" label="Product Expiry Date/Time" value={aaData.productExpiryDate || null} error={errors.productExpiryhDate} onChange={datePickerChangeHandler} />
				</Grid>
			</Grid>
			<Grid item md={12} xs={12}>
				<FormControlLabel control={<Switch id="isProductApproved" checked={aaData.isProductApproved} onChange={(e) => onChange("isProductApproved", e.target.checked)} />} label="Product Approved" />
			</Grid>
			<Grid item md={12} xs={12}>
				<Divider />
			</Grid>
		</Grid>
	);
};

export default AirasiaDataForm;
